<template>
  <div>
    <div class="comment" v-if="false">
      <!-- 健康报告得分和五个指标评语，三个指数显示组件 -->
      <div class="left-comment">
        <div class="left-comment-top">
          <div class="score-ranking-div">
            <div id="myChartsScore" style="width: 80px; height: 70px; margin: 0 auto; top: 0px" key="myChartsScore"></div>
            <div class="score-ranking-tips " :class="scoreLabel == '一般' ? 'score-ranking-tips-red' : ''">
              {{ scoreLabel }}
            </div>
            <div class="score-ranking">
              <!-- <div
              class="score-ranking"
              style="text-align: center; margin-bottom: -5px"
            >
              {{ oneDayData.smDetail.sleepComment }}
            </div> -->
              超过{{ sleepProportion }}%的用户
            </div>
          </div>
          <div class="progress-div">
            <div class="progress-item" v-for="(item, index) in userIndexList" :key="index" @mouseenter="mouseenterOfItem(index)" @mouseleave="mouseleaveOfItem">
              <div class="progress-item-line">
                <div class="progress-item-line-bg"></div>
                <div class="progress-item-line-out" :class="
                    item.comment == '正常' || item.comment == '优秀'
                      ? ''
                      : 'progress-item-line-out-alarm'
                  " :style="{ height: item.value + '%' }"></div>
              </div>
              <div class="progress-decs">{{ item.name }}</div>
              <div :class="
                  item.comment == '正常' || item.comment == '优秀'
                    ? ''
                    : 'progress-red'
                " class="progress-comment">
                {{ item.comment }}
              </div>
              <div class="progress-pop" :style="{
                  color:
                    item.comment == '正常' || item.comment == '优秀'
                      ? ''
                      : '#FF7186',
                }" v-if="item.isShow">
                {{ item.value }}分
              </div>
            </div>
          </div>
        </div>
        <div class="splice-line"></div>
        <div class="left-comment-bottom">
          <div class="left-comment-bottom-item">
            <div style="display:flex;width:145px">
              <img class="left-comment-bottom-item-image" src="../../../assets/img/report_index_icon_bed_d@2x.png" />
              <span style="margin:0 4px 0 8px;">上床时间</span>
              <span class="color-time"> {{ getBedIdx }}</span>
            </div>
            <div class="titlt-conter"></div>
            <div class="index-red-p">
              <span class="titlt-beforer">入睡时间</span>
              <span class="color-time"> {{ sleepStIdx }}</span>
              <div class="index-end index-red" v-if="sleepStIdxSuggest">
                建议00:00前入睡
              </div>
            </div>
          </div>
          <div class="left-comment-bottom-item" style="margin-top:20px;">
            <div style="display:flex;width:145px">
              <img class="left-comment-bottom-item-image" src="../../../assets/img/report_index_icon_clock_d@2x.png" />
              <span style="margin:0 4px 0 8px;">醒来时间</span>
              <span class="color-time"> {{ sleepEdIdx }}</span>
            </div>
            <div class="titlt-conter"></div>
            <div>
              <span class="titlt-beforer">起床时间</span>
              <span class="color-time"> {{ leaveBedIdx }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="right-comment">
        <div class="comment-li">
          <div class="comment-li-item">
            <div class="comment-li-item-circle" :style="{
                background: sleepDuration.comment == '正常' ? '' : '#FF7186',
              }"></div>
            <div>睡眠时长</div>
            <div>{{ sleepDuration.allIndexValue }}</div>
            <div class="comment-li-item-tips" :style="{
                background: sleepDuration.comment == '正常' ? '' : '#FF7186',
              }">
              {{ sleepDuration.comment }}
            </div>
          </div>
          <div class="comment-li-item">
            <div class="comment-li-item-circle" :style="{
                background:
                  deepSleepDuration.comment == '正常' ? '' : '#FF7186',
              }"></div>
            <div>深睡时长</div>
            <div>{{ deepSleepDuration.allIndexValue }}</div>
            <div class="comment-li-item-tips" :style="{
                background:
                  deepSleepDuration.comment == '正常' ? '' : '#FF7186',
              }">
              {{ deepSleepDuration.comment }}
            </div>
          </div>

          <div class="comment-li-item">
            <div class="comment-li-item-duble">
              <div class="comment-li-item-circle" :style="{
                  background: wakeUpDuration.comment == '正常' ? '' : '#FF7186',
                }"></div>
              <div>夜醒时长</div>
              <div>{{ wakeUpDuration.allIndexValue }}</div>
              <div class="comment-li-item-tips" :style="{
                  background: wakeUpDuration.comment == '正常' ? '' : '#FF7186',
                }">
                {{ wakeUpDuration.comment }}
              </div>
            </div>
            <div class="comment-li-item-line"></div>
            <div class="comment-li-item-duble">
              <div class="comment-li-item-circle" :style="{
                  background: outBedNum.comment == '正常' ? '' : '#FF7186',
                }"></div>
              <div>离床</div>
              <div>{{ outBedNum.allIndexValue }}</div>
              <div class="comment-li-item-tips" :style="{
                  background: outBedNum.comment == '正常' ? '' : '#FF7186',
                }">
                {{ outBedNum.comment }}
              </div>
            </div>
          </div>
          <div class="comment-li-item">
            <div class="comment-li-item-duble">
              <div class="comment-li-item-circle" :style="{
                  background:
                    sleepStDuration.comment == '正常' ? '' : '#FF7186',
                }"></div>
              <div>入睡时长</div>
              <div>{{ sleepStDuration.allIndexValue }}</div>
              <div class="comment-li-item-tips" :style="{
                  background:
                    sleepStDuration.comment == '正常' ? '' : '#FF7186',
                }">
                {{ sleepStDuration.comment }}
              </div>
            </div>
            <div class="comment-li-item-line"></div>
            <div class="comment-li-item-duble">
              <div class="comment-li-item-circle" :style="{
                  background: sleepEff.comment == '正常' ? '' : '#FF7186',
                }"></div>
              <div>
                睡眠效率
              </div>
              <div>{{ sleepEff.allIndexValue }}</div>
              <div class="comment-li-item-tips" :style="{
                  background: sleepEff.comment == '正常' ? '' : '#FF7186',
                }">
                {{ sleepEff.comment }}
              </div>
            </div>
          </div>
          <div class="comment-li-item">
            <div class="comment-li-item-circle" :style="{
                background: turnOverIndex.comment == '正常' ? '' : '#FF7186',
              }"></div>
            <div>体动</div>
            <div>{{ turnOverNum }}</div>
            <div>次·</div>
            <div>体动指数</div>
            <div>{{ turnOverIndex.allIndexValue }}</div>
            <div class="comment-li-item-tips" :style="{
                background: turnOverIndex.comment == '正常' ? '' : '#FF7186',
              }">
              {{ turnOverIndex.comment }}
            </div>
            <div class="tooltip" style="height: 24px;">
              <img style="width:20px;height:20px;" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/QL_official_account/wenhaoIcon.png" alt="" />
              <div class="tooltiptext">
                <div class="ahi-title">
                  体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comment-details-indexs">
      <div>
        <div v-for="(item, jindex) in detailedInterData" :key="jindex + 12" style="width: 422px;">
          <div class="comment-details-item" v-if="jindex % 2 == 0" :class="{ 'is-alarm': item.normalFlag !== 0 }">
            <div class="comment-details-item-box">
              <div class="details-title">
                <div class="details-title-icon">
                  <img src="../../../assets/img/report_icon_notice_d@2x.png" alt="" srcset="" />
                </div>
                <div style="margin-right:6px;">{{ item.indexName == '离床次数' ? '睡眠间离床次数' : item.indexName }}</div>
                <div class="details-title-num" v-if="item.indexValHour != 0">
                  {{ item.indexValHour }}
                </div>
                <div v-if="item.indexValHour != 0">小时</div>
                <div class="details-title-num" v-if="item.indexValMinute != 0 && item.indexVal == ''">
                  {{ item.indexValMinute }}
                </div>
                <div v-if="item.indexValMinute != 0 && item.indexVal == ''">
                  分钟
                </div>
                <div class="details-title-num" v-if="item.indexVal != '' && item.indexValMinute == 0">
                  {{ item.indexVal }}
                </div>
                <div v-if="item.indexName == '离床次数'">次</div>
              </div>
              <div class="details-title ml24" v-if="item.continuityDays != ''">
                <div>连续</div>
                <div class="details-title-num">{{ item.continuityDays }}</div>
                <div>{{ item.continuityDaysText }}</div>
              </div>
              <div class="ml24 details-consult">{{ item.referenceValue }}</div>
              <div class="detailed-inter" :style="{ height: item.isShowDetailBox ? '100%' : '45px' }">
                <div class="detailed-inter-title" @click="changeShowDetailBox">
                  <div>详细解读</div>
                  <img v-if="item.isShowDetailBox" src="../../../assets/img/icon_unscramble_up_h@2x.png" alt="" srcset="" />
                  <img v-else src="../../../assets/img/icon_unscramble_down_h@2x.png" alt="" srcset="" />
                </div>
                <div class="detailed-inter-line"></div>
                <div>
                  <div class="detailstr-circle" v-for="(ktem, kindex) in item.detailStr" :key="kindex + 's'">
                    {{ ktem }}
                  </div>
                  <div class="advice-item" :style="{
                      alignItems:
                        item.indexName == '离床次数' ? 'flex-start' : '',
                    }" v-for="(ytem, yindex) in item.advice" :key="yindex + 't'">
                    <img :src="
                        require('../../../assets/img/' +
                          ytem.imageName +
                          '.png')
                      " alt="" srcset="" />
                    <div v-html="ytem.adviceText"></div>
                  </div>
                  <div class="detailstr-circle" v-if="item.lastText !== ''">
                    {{ item.lastText }}
                  </div>
                </div>
              </div>
              <div class="tdxq-con" v-if="item.indexName == '体动指数' && item.extendData.num > 0">
                <div class="le">体动详情</div>
                <div class="r">共{{ item.extendData.num }}次</div>
              </div>
              <div v-if="item.indexName == '体动指数' && item.extendData.num > 0" id="day-tdxq" style="height:126px">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-for="(item, jindex) in detailedInterData" :key="jindex">
          <div class="comment-details-item" v-if="jindex % 2 !== 0" :class="{ 'is-alarm': item.normalFlag !== 0 }">
            <div class="comment-details-item-box">
              <div class="details-title">
                <div class="details-title-icon">
                  <img src="../../../assets/img/report_icon_notice_d@2x.png" alt="" srcset="" />
                </div>
                <div style="margin-right:6px;">{{ item.indexName == '离床次数' ? '睡眠间离床次数' : item.indexName }}</div>
                <div class="details-title-num" v-if="item.indexValHour != 0">
                  {{ item.indexValHour }}
                </div>
                <div v-if="item.indexValHour != 0">小时</div>
                <div class="details-title-num" v-if="item.indexValMinute != 0 && item.indexVal == ''">
                  {{ item.indexValMinute }}
                </div>
                <div v-if="item.indexValMinute != 0 && item.indexVal == ''">
                  分钟
                </div>
                <div class="details-title-num" v-if="item.indexVal != '' && item.indexValMinute == 0">
                  {{ item.indexVal }}
                </div>
                <div v-if="item.indexName == '离床次数'">次</div>
              </div>
              <div class="details-title ml24" v-if="item.continuityDays != ''">
                <div>连续</div>
                <div class="details-title-num">{{ item.continuityDays }}</div>
                <div>{{ item.continuityDaysText }}</div>
              </div>
              <div class="ml24 details-consult">{{ item.referenceValue }}</div>
              <div class="detailed-inter" :style="{ height: item.isShowDetailBox ? '100%' : '45px' }">
                <div class="detailed-inter-title" @click="changeShowDetailBox">
                  <div>详细解读</div>
                  <img v-if="item.isShowDetailBox" src="../../../assets/img/icon_unscramble_up_h@2x.png" alt="" srcset="" />
                  <img v-else src="../../../assets/img/icon_unscramble_down_h@2x.png" alt="" srcset="" />
                </div>
                <div class="detailed-inter-line"></div>
                <div>
                  <div class="detailstr-circle" v-for="(ktem, kindex) in item.detailStr" :key="kindex + 's'">
                    {{ ktem }}
                  </div>
                  <div class="advice-item" :style="{
                      alignItems:
                        item.indexName == '离床次数' ? 'flex-start' : '',
                    }" v-for="(ytem, yindex) in item.advice" :key="yindex + 't'">
                    <img :src="
                        require('../../../assets/img/' +
                          ytem.imageName +
                          '.png')
                      " alt="" srcset="" />
                    <div v-html="ytem.adviceText"></div>
                  </div>
                  <div class="detailstr-circle" v-if="item.lastText !== ''">
                    {{ item.lastText }}
                  </div>
                </div>
              </div>
              <div class="tdxq-con" v-if="item.indexName == '体动指数' && item.extendData.num > 0">
                <div class="le">体动详情</div>
                <div class="r">共{{ item.extendData.num }}次</div>
              </div>
              <div v-if="item.indexName == '体动指数' && item.extendData.num > 0" id="day-tdxq" style="height:126px">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: {
    score: 0,
    detailsData: {},
    dataTitleList: null,
    beginTime: "",
    endTime: "",
    sleepEffect: null,
    getBedTime: "",
    leaveBedTime: "",
    outEnd: false,
    outLeave: false,
    searchTime: "",
    searchBedId: "",
    oneDayData: {}, //getSleepReportOneDay接口数据
  },
  data() {
    return {
      myChart5day: null,
      leaveBedIdx: "",
      sleepEdIdx: "",
      sleepStIdx: "",
      sleepStIdxSuggest: false,
      getBedIdx: "",
      sleepProportion: "",
      scoreLabel: "优秀",
      myChartScore: null,
      good: 0,
      lateSleep: false,
      detailedInterData: [
        {
          indexName: "", // 指标名称
          indexH: "", // 入睡时长、睡眠时长、夜醒时长、深睡时长、睡眠时长中的 小时
          indexM: "", // 入睡时长、睡眠时长、夜醒时长、深睡时长、睡眠时长中的 分钟
          indexVal: "", // 离床次数 睡眠效率 体动指数 中的数值
          参考: "", // 参考值前端固定写死
          detailStr: [],
          advice: [
            {
              imageName: "yundong",
              adviceText: "qweqweqw",
            },
            {
              imageName: "yundong",
              adviceText: "qweqweqw",
            },
          ],
          lastText: "",
          extendData: {
            name: "体动详情",
            num: 200, // 共体动了多少次
            data: [
              0, 1, 2, 1, 0, 0, 5, 3, 5, 3, 10, 4, 0, 4, 2, 0, 0, 2, 4, 0, 0, 0,
              1, 0, 0, 1, 3, 1, 3, 3, 1, 0,
            ],
            xtimeAxis: [
              "23:00",
              "23:15",
              "23:30",
              "23:45",
              "00:00",
              "00:15",
              "00:30",
              "00:45",
              "01:00",
              "01:15",
              "01:30",
              "01:45",
              "02:00",
              "02:15",
              "02:30",
              "02:45",
              "03:00",
              "03:15",
              "03:30",
              "03:45",
              "04:00",
              "04:15",
              "04:30",
              "04:45",
              "05:00",
              "05:15",
              "05:30",
              "05:45",
              "06:00",
              "06:15",
              "06:30",
              "06:45",
            ],
          }, // 体动柱状图数据
        },
      ],
      sleepDuration: {
        allIndexValue: "",
        comment: "",
      },
      deepSleepDuration: {
        allIndexValue: "",
        comment: "",
      },
      wakeUpDuration: {
        allIndexValue: "",
        comment: "",
      },

      outBedNum: {
        allIndexValue: "",
        comment: "",
      },

      sleepStDuration: {
        allIndexValue: "",
        comment: "",
      },

      sleepEff: {
        allIndexValue: "",
        comment: "",
      },

      turnOverIndex: {
        allIndexValue: "",
        comment: "",
      },
      turnOverNum: "",
      userIndexList: [],
    };
  },
  mounted() {
    //this.waterFall();
    this.getWebOneDayReport();
  },
  methods: {
    // 改变显示详细解读状态
    changeShowDetailBox() {
      this.detailedInterData.forEach((item) => {
        item.isShowDetailBox = !item.isShowDetailBox;
      });
    },
    getWebOneDayReport() {
      let params = {
        bedId: this.searchBedId,
        date: this.searchTime,
        // bedId: 1220,
        // date: '2023-06-28',
        reportType: 0,
      };
      this.$get(
        "/api/v3/report/getWebOneDayReport",
        params,
        (res) => {
          if (res.code == 0) {
            console.log(res.data);
            this.changeSleepIndexData(res.data.sleepIndexList);

            this.turnOverNum = res.data.turnOverNum;
            this.sleepProportion = res.data.sleepProportion;
            this.leaveBedIdx = res.data.leaveBedIdx;
            this.sleepEdIdx = res.data.sleepEdIdx;
            this.sleepStIdx = res.data.sleepStIdx;
            this.sleepStIdxSuggest = res.data.sleepStIdxSuggest;
            this.getBedIdx = res.data.getBedIdx;
            this.scoreLabel = res.data.scoreLabel;
            this.userIndexList = res.data.userIndexList;
            this.userIndexList.forEach((item) => {
              item.isShow = false;
            });
            // this.getChartScore(res.data.score);

            res.data.sleepIndexList.forEach((item) => {
              if (item.index == "sleepDuration") {
                console.log(item.allIndexValue);
                this.sleepDuration = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "wakeUpDuration") {
                this.wakeUpDuration = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "outBedNum") {
                this.outBedNum = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "sleepStDuration") {
                this.sleepStDuration = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "sleepEff") {
                this.sleepEff = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "turnOverIndex") {
                this.turnOverIndex = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              } else if (item.index == "deepSleepDuration") {
                this.deepSleepDuration = {
                  allIndexValue: item.allIndexValue,
                  comment: item.comment,
                };
              }
            });
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          this.$message.error("服务端发生异常");
        }
      );
    },
    mouseenterOfItem(index) {
      this.userIndexList[index].isShow = !this.userIndexList[index].isShow;
      this.$forceUpdate();
    },
    mouseleaveOfItem() {
      this.userIndexList.forEach((item) => {
        item.isShow = false;
      });
      this.$forceUpdate();
    },
    changeSleepIndexData(sleepIndexList) {
      console.log(sleepIndexList);
      let resData = [];
      sleepIndexList.forEach((item, index) => {
        if (item.normalFlag != 0) {
          let resDataItem = {};
          resDataItem.indexName = item.indexName; // 指标名称
          resDataItem.indexValHour = item.indexValHour; // 入睡时长、睡眠时长、夜醒时长、深睡时长、睡眠时长中的 小时
          resDataItem.indexValMinute = item.indexValMinute; // 入睡时长、睡眠时长、夜醒时长、深睡时长、睡眠时长中的 分钟
          resDataItem.indexVal = item.indexVal; // 离床次数 睡眠效率 体动指数 中的数值
          resDataItem.detailStr = []; // 详细解读文字信息
          resDataItem.continuityDays = item.continuityDays; // 连续多少天发生了啥事
          resDataItem.isShowDetailBox = false; // 连续多少天发生了啥事
          if (item.normalFlag == 1) {
            // 睡眠指标详细解读一般超范围
            if (item.indexName == "睡眠时长") {
              resDataItem.referenceValue = "参考值：6~10小时"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "一项在美国威斯康辛州开展的睡眠健康随访研究发现，睡眠时间与体重指数BMI之间的关系呈U型相关，睡眠时间过短或过长皆有可能导致肥胖风险增加"
              );
              if (item.normalFlagSleepDuration == 6) {
                resDataItem.continuityDaysText = "晚睡眠时长小于6小时";
                resDataItem.detailStr.push(
                  "建议您尝试睡前泡脚放松，规律作息，定点休息，避免睡眠环境的光照和噪音，持续观察睡眠时长变化"
                );
              } else if (item.normalFlagSleepDuration == 10) {
                resDataItem.continuityDaysText = "晚睡眠时长大于10小时";
                resDataItem.detailStr.push(
                  "建议您尝试睡前泡脚放松，规律作息，定点起床，避免睡眠环境的光照和噪音，持续观察睡眠时长变化"
                );
              }
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "深睡时长") {
              resDataItem.referenceValue = "参考值：20%～60%"; // 参考值前端固定写死
              if (item.normalFlagDeepDuration == 20) {
                resDataItem.continuityDaysText = "晚深睡时长少于20%";
                resDataItem.detailStr.push(
                  "荷兰神经科学研究所的伊斯布兰德·范德韦夫及同事在《自然神经学》杂志发表报告指出深度睡眠过短会导致记忆力变差。"
                );
                resDataItem.detailStr.push(
                  "美国斯坦福大学的研究团队随访持续21年的分析结果表明，深度睡眠不良与全因死亡率及心血管疾病发作风险升高有关。"
                );
                resDataItem.detailStr.push(
                  "建议您尝试睡前听听音乐，泡泡脚，放松心情，按时睡觉，规律作息， 减少卧室灯光和声音，持续观察深睡时长变化"
                );
              } else if (item.normalFlagDeepDuration == 60) {
                resDataItem.continuityDaysText = "晚深睡时长大于60%";
                resDataItem.detailStr.push(
                  "深睡眠是人体黄金睡眠，一般深睡眠占比在20%～60%，具体情况因人而异。过长的深睡眠可能是过度劳累或者身体某种疾病导致的，如没有明显的不适，顺其自然就好，不用过度担心"
                );
                resDataItem.detailStr.push(
                  "建议您尝试规律作息，条件允许的情况下适度午休，放松心情，缓解身体疲劳，持续观察深睡时长变化"
                );
              }
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "夜醒时长") {
              resDataItem.continuityDaysText = "晚夜醒时长超过31分钟";
              resDataItem.referenceValue = "参考值：≤31分钟"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "根据《睡眠医学》的研究，如果连续6个月每周都至少发生3次夜间觉醒时间超过31分钟，即可定义为失眠"
              );
              resDataItem.detailStr.push(
                "建议您尝试睡前减少饮水，减少卧室灯光和声音，每周坚持适量运动，持续观察夜醒时长变化"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "离床次数") {
              resDataItem.continuityDaysText = "晚离床次数超过2次";
              resDataItem.referenceValue = "参考值：0～2次"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "专家表示，一般情况下人起夜的次数在0～2次，起夜次数超过2次，可能在反应人体出现的一些问题"
              );
              resDataItem.detailStr.push(
                "建议您尝试在平时少吃盐，且在睡前半小时内少喝水，持续关注一下近期离床次数的变化"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "睡眠效率") {
              resDataItem.continuityDaysText = "晚睡眠效率小于80%";
              resDataItem.referenceValue = "参考值：≥80%"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "有研究表明，睡眠效率小于80%是肥胖发生的一个危险因素"
              );
              resDataItem.detailStr.push(
                "建议您尝试不要在床上玩手机，规律作息，每周坚持适量运动，持续观察睡眠效率变化"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "入睡时长") {
              resDataItem.continuityDaysText = "晚入睡时长超过30分钟";
              resDataItem.referenceValue = "参考值：<30分钟"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "依据世界卫生组织(WHO)标准，连续一个月每周至少有3天出现上床30分钟无法入睡即可判定为失眠"
              );
              resDataItem.detailStr.push(
                "建议您尝试不要在床上玩手机，规律作息，每周坚持适量运动，持续观察入睡时长变化"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            } else if (item.indexName == "体动指数") {
              let tdxq = {
                xAxis: {
                  data: item.extendData.xtimeAxis, //X轴通用呼吸周期
                  min: "",
                  max: "",
                },
                yAxis: {
                  min: "",
                  max:
                    item.extendData.max % 2 == 0
                      ? item.extendData.max
                      : item.extendData.max + 1,
                },
                series: {
                  data: item.extendData.data,
                },
              };
              setTimeout(() => {
                this.$nextTick(() => {
                  this.getMyChart5("day-tdxq", tdxq);
                });
              }, 100);
              resDataItem.referenceValue = "参考值：1.25～15"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间。"
              );
              resDataItem.detailStr.push(
                "体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，如无其他不适，均视为正常，无需过度担心"
              );
              resDataItem.detailStr.push(
                "建议您尝试规律作息，睡前放松，每周坚持适量运动，持续观察提动指数变化"
              );
              console.log(1203, item.normalFlagTurnOverIndex);
              if (item.normalFlagTurnOverIndex == 1.25) {
                console.log(1205, item.normalFlagTurnOverIndex);
                resDataItem.continuityDaysText = "晚体动指数小于1.25";
              } else if (item.normalFlagTurnOverIndex == 15) {
                resDataItem.continuityDaysText = "晚体动指数大于15";
              }
              resDataItem.extendData = item.extendData; //体动指数柱状图数据
              resDataItem.lastText = "";
              console.log(resDataItem, "resDataItem");
            } else if (item.indexName == "跌倒风险") {
              resDataItem.continuityDaysText = "";
              resDataItem.referenceValue = "参考值：≤50"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "跌倒风险反映的是使用者跌倒的可能性，分数越高，跌倒的风险越高"
              );
              resDataItem.detailStr.push(
                "建议您适当放松休息一下，并避免长时间站立或在疲劳或草率的情况下进行活动，特别是户外活动。在必要的情况下，可以接受他人的帮助，避免过度冒险"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            }
          } else if (item.normalFlag == 2) {
            // 睡眠指标详细解读连续性
            if (item.indexName == "睡眠时长") {
              resDataItem.referenceValue = "参考值：6~10小时"; // 参考值前端固定写死
              if (item.normalFlagSleepDuration == 6) {
                resDataItem.continuityDaysText = "晚睡眠时长小于6小时";
                resDataItem.detailStr.push(
                  "根据美国南佛罗里达大学衰老研究学院助理教授Soomi Lee研究发现，只需要连续3个晚上的睡眠时长小于6小时，就足以导致人的精神和身体健康状况出现严重恶化"
                );
                resDataItem.detailStr.push("建议您尝试如下改善：");
                resDataItem.advice = [
                  {
                    imageName: "guilv",
                    adviceText: " 制定规律的作息时间，并严格遵守",
                  },
                  {
                    imageName: "wendu",
                    adviceText:
                      "睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松",
                  },
                  {
                    imageName: "wuxiu",
                    adviceText: "午睡别太久，20 分钟左右为宜",
                  },
                  {
                    imageName: "yundong",
                    adviceText:
                      "每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              } else if (item.normalFlagSleepDuration == 10) {
                resDataItem.continuityDaysText = "晚睡眠时长大于10小时";
                resDataItem.detailStr.push(
                  "英国基尔大学的科学家在对74项研究涉及300余万人的研究分析发现，与睡7个小时相比，睡10个小时的死亡风险会提高30%。与此同时，死于中风的风险会提高56%，死于心血管疾病的风险会提高49%。"
                );
                resDataItem.detailStr.push("建议您尝试如下改善：");
                resDataItem.advice = [
                  {
                    imageName: "guilv",
                    adviceText: " 制定规律的作息时间，并严格遵守",
                  },
                  {
                    imageName: "wendu",
                    adviceText:
                      "睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松",
                  },
                  {
                    imageName: "wuxiu",
                    adviceText: "午睡别太久，20 分钟左右为宜",
                  },
                  {
                    imageName: "yundong",
                    adviceText:
                      "每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              }
              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "深睡时长") {
              resDataItem.referenceValue = "参考值：20%～60%"; // 参考值前端固定写死
              if (item.normalFlagDeepDuration == 20) {
                resDataItem.continuityDaysText = "晚深睡时长少于20%";
                resDataItem.detailStr.push(
                  "荷兰神经科学研究所的伊斯布兰德·范德韦夫及同事在《自然神经学》杂志发表报告指出深度睡眠过短会导致记忆力变差。"
                );
                resDataItem.detailStr.push(
                  "美国斯坦福大学的研究团队随访持续21年的分析结果表明，深度睡眠不良与全因死亡率及心血管疾病发作风险升高有关。"
                );
                resDataItem.detailStr.push("建议您尝试如下改善：");
                resDataItem.advice = [
                  {
                    imageName: "yanjiu",
                    adviceText: "远离烟酒，晚餐避免大吃大喝",
                  },
                  {
                    imageName: "wendu",
                    adviceText:
                      "睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松",
                  },
                  {
                    imageName: "wuxiu",
                    adviceText: "午睡别太久，20 分钟左右为宜",
                  },
                  {
                    imageName: "yundong",
                    adviceText:
                      "每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              } else if (item.normalFlagDeepDuration == 60) {
                resDataItem.continuityDaysText = "晚深睡时长大于60%";
                resDataItem.detailStr.push(
                  "深睡眠是人体黄金睡眠，一般深睡眠占比在20%～60%，具体情况因人而异。过长的深睡眠可能是过度劳累或者身体某种疾病导致的，长期的深睡眠过长，可能会引发头痛、头晕等不适的症状，导致大脑的神经缺乏敏感性，大脑的神经中枢受到影响，容易发生注意力不集中和反应较迟钝的现象，影响日常生活和生命健康"
                );
                resDataItem.detailStr.push("建议您尝试如下改善");
                resDataItem.advice = [
                  {
                    imageName: "guilv",
                    adviceText:
                      "合理安排工作和生活节奏，坚持规律的作息，早上按固定时间起床，不要赖床",
                  },
                  {
                    imageName: "wuxiu",
                    adviceText: "午睡别太久，20 分钟左右为宜",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              }
              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "夜醒时长") {
              resDataItem.continuityDaysText = "晚夜醒时长超过31分钟";
              resDataItem.referenceValue = "参考值：≤31分钟"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "根据《睡眠医学》的研究，如果连续6个月每周都至少发生3次夜间觉醒时间超过31分钟，即可定义为失眠"
              );
              resDataItem.detailStr.push("建议您尝试如下改善：");
              resDataItem.advice = [
                {
                  imageName: "kafei",
                  adviceText:
                    "睡前2小时不要喝咖啡或酒，不要过度饮水，控制一下饮食",
                },
                {
                  imageName: "wendu",
                  adviceText:
                    "睡眠环境尽量避免光照和噪音，室温保持在18~24℃，选择舒适的床品，睡前泡脚放松",
                },
                {
                  imageName: "wuxiu",
                  adviceText: "午睡别太久，20 分钟左右为宜",
                },
                {
                  imageName: "yundong",
                  adviceText:
                    "每周3～5次30分钟有氧运动，避开睡前3小时，放松心情，释放压力",
                },
              ];
              resDataItem.lastText =
                " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "离床次数") {
              resDataItem.continuityDaysText = "晚离床次数超过2次";
              resDataItem.referenceValue = "参考值：0～2次"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "专家表示，一般情况下人起夜的次数在0～2次，起夜次数超过2次，且持续多日，则说明夜尿频率高，与之相关的疾病包括：糖尿病、前列腺增生、泌尿系统感染等，需要引起警惕"
              );
              resDataItem.detailStr.push("建议您尝试如下改善：");
              resDataItem.advice = [
                {
                  imageName: "chiyan",
                  adviceText:
                    "平常少吃盐<br/>英国一项研究发现，减少食盐的摄入量，可明显减少起夜的次数。晚餐尤其要吃得清淡些，同时要减少高蛋白食物的摄入",
                },
                {
                  imageName: "heshui",
                  adviceText:
                    "睡前半小时内少喝水<br/>建议在睡觉前半小时，稍微抿上两口，最多不超过一杯（200毫升）",
                },
                {
                  imageName: "juhua",
                  adviceText:
                    "经常做提肛运动<br/>盆底部肌肉松弛，膀胱括约肌萎缩，包括膀胱弹性差，较少的尿量就会引起较强的尿意，所以提肛运动有助于增强盆底肌肉的力量，很好地减少起夜次数",
                },
              ];
              resDataItem.lastText =
                " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "睡眠效率") {
              resDataItem.continuityDaysText = "晚睡眠效率小于80%";
              resDataItem.referenceValue = "参考值：≥80%"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "有研究表明，睡眠效率小于80%是肥胖发生的一个危险因素"
              );
              resDataItem.detailStr.push("建议您尝试如下改善：");
              resDataItem.advice = [
                {
                  imageName: "guilv",
                  adviceText:
                    "合理安排工作和生活节奏，坚持规律的作息，有困意的时候再上床睡觉",
                },
                {
                  imageName: "dianzi",
                  adviceText: "睡前远离电子设备，在床上不要玩手机、看书",
                },
                {
                  imageName: "yundong",
                  adviceText:
                    "每周坚持3～5次30分钟有氧运动，放松心情，释放压力",
                },
              ];
              resDataItem.lastText =
                " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";

              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "入睡时长") {
              resDataItem.continuityDaysText = "晚入睡时长超过30分钟";
              resDataItem.referenceValue = "参考值：<30分钟"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "依据世界卫生组织(WHO)标准，连续一个月每周至少有3天出现上床30分钟无法入睡即可判定为失眠"
              );
              resDataItem.detailStr.push("建议您尝试如下改善：");
              resDataItem.advice = [
                {
                  imageName: "guilv",
                  adviceText:
                    "合理安排工作和生活节奏，坚持规律的作息，按时上床睡觉",
                },
                {
                  imageName: "dianzi",
                  adviceText: "睡前远离电子设备，在床上不要玩手机、看书",
                },
                {
                  imageName: "yundong",
                  adviceText:
                    "每周坚持3～5次30分钟有氧运动，放松心情，释放压力",
                },
              ];
              resDataItem.lastText =
                " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              resDataItem.extendData = {}; //体动指数柱状图数据
            } else if (item.indexName == "体动指数") {
              resDataItem.referenceValue = "参考值：1.25～15"; // 参考值前端固定写死

              if (item.normalFlagTurnOverIndex == 1.25) {
                resDataItem.continuityDaysText = "晚体动指数小于1.25";
                resDataItem.detailStr.push(
                  "根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间"
                );
                resDataItem.detailStr.push(
                  "体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过少体现的是您睡觉非常平稳，如果没有其他明显不适，均视为正常，无需过度担心"
                );
                resDataItem.detailStr.push("建议您尝试如下改善：");
                resDataItem.advice = [
                  {
                    imageName: "guilv",
                    adviceText: "制定规律的作息时间，并严格遵守",
                  },
                  {
                    imageName: "wuxiu",
                    adviceText: "适度午休，20分钟左右为宜",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              } else if (item.normalFlagTurnOverIndex == 15) {
                resDataItem.continuityDaysText = "晚体动指数大于15";
                resDataItem.detailStr.push(
                  "根据大数据的分析，大多数人的体动指数集中分布在1.25～15之间"
                );
                resDataItem.detailStr.push(
                  "体动体现的是您睡眠期间身体活动的规律，包括翻身和其他身体活动的记录，一般来说，我们都会有睡眠期间的体动，体动过多体现的是您睡觉不踏实，睡眠质量不够好，如果没有其他明显不适，均视为正常，无需过度担心"
                );
                resDataItem.detailStr.push("建议您尝试如下改善：");
                resDataItem.advice = [
                  {
                    imageName: "yanjiu",
                    adviceText: "远离烟酒，晚餐避免大吃大喝",
                  },
                  {
                    imageName: "dianzi",
                    adviceText: "睡前远离电子设备，在床上不要玩手机、看书",
                  },
                  {
                    imageName: "yundong",
                    adviceText:
                      "每周坚持3～5次30分钟有氧运动，放松心情，释放压力",
                  },
                ];
                resDataItem.lastText =
                  " 在尝试了上述方法后，您可以持续观察睡眠时长的变化，如果超过6个月依然没有改善，可以找专业的医生寻求帮助";
              }
              let tdxq = {
                xAxis: {
                  data: item.extendData.xtimeAxis, //X轴通用呼吸周期
                  min: "",
                  max: "",
                },
                yAxis: {
                  min: "",
                  max:
                    item.extendData.max % 2 == 0
                      ? item.extendData.max
                      : item.extendData.max + 1,
                },
                series: {
                  data: item.extendData.data,
                },
              };
              setTimeout(() => {
                this.$nextTick(() => {
                  this.getMyChart5("day-tdxq", tdxq);
                });
              }, 100);
              resDataItem.extendData = item.extendData; //体动指数柱状图数据\
            } else if (item.indexName == "跌到风险") {
              resDataItem.continuityDaysText = "";
              resDataItem.referenceValue = "参考值：≤50"; // 参考值前端固定写死
              resDataItem.detailStr.push(
                "跌倒风险反映的是使用者跌倒的可能性，分数越高，跌倒的风险越高"
              );
              resDataItem.detailStr.push(
                "建议您适当放松休息一下，并避免长时间站立或在疲劳或草率的情况下进行活动，特别是户外活动。在必要的情况下，可以接受他人的帮助，避免过度冒险"
              );
              resDataItem.extendData = {}; //体动指数柱状图数据
              resDataItem.lastText = "";
            }
          }
          // detailStr: [
          //   '根据暗杀可杀就杀开始的卡仕达卡仕达卡号山东科技安徽省大会上的哈抠脚大汉卡号的刷卡',
          //   'ashhasdkhaksdhkjahsdkaskjhajskdhjkashd',
          //   'akshkahsjasdkhasdh',
          // ],
          // advice: [
          //   {
          //     imageName: '',
          //     adviceText: 'qweqweqw',
          //   },
          //   {
          //     imageName: '',
          //     adviceText: 'qweqweqw',
          //   },
          // ],
          // lastText: '尝试没有效果后你应该去死',
          // extendData: {
          // }, //体动指数柱状图数据
          resData.push(resDataItem);
        }
      });
      this.detailedInterData = resData;
      console.log(resData, "resDataresDataresData");
    },
    getChartScore(nowScore) {
      console.log(nowScore);
      if (this.myChartScore) {
        this.myChartScore.dispose();
      }
      this.myChartScore = this.$echarts.init(
        document.getElementById("myChartsScore"),
        null,
        { devicePixelRatio: 2.5 }
      );
      var optionScore = {
        title: {
          bottom: "10%",
          left: "center",
        },
        grid: {
          // 让图表占满容器
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px",
        },
        series: [
          // 是否正常
          {
            type: "gauge",
            radius: "100%",
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              fontSize: 12,
              color: "#5A5A89",
              offsetCenter: ["0", "5%"],
              formatter: (value) => {
                // return value;
              },
            },
            data: [
              {
                value: 100,
              },
            ],
          },
          // 主图
          {
            type: "gauge",
            radius: "100%",
            startAngle: 220,
            endAngle: -40,
            min: 0,
            max: 100,
            splitNumber: 12,
            itemStyle: {
              normal: {
                color:
                  this.scoreLabel == "一般"
                    ? new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "rgba(255, 113, 134, 1)",
                        },
                        {
                          offset: 1,
                          color: "rgba(255, 128, 186, 1)",
                        },
                      ])
                    : new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "rgba(75, 140, 249, 1)",
                        },
                        {
                          offset: 0.5,
                          color: "rgba(109, 148, 249, 1)",
                        },
                        {
                          offset: 1,
                          color: "rgba(190, 168, 252, 1)",
                        },
                      ]),
              },
            },
            progress: {
              show: true,
              roundCap: true,
              width: 10,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 10,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            title: {
              show: false,
            },
            detail: {
              fontSize: 22,
              fontFamily: "DINAlternate-Bold",
              fontWeight: 900,
              color: this.scoreLabel == "一般" ? "#FF7186" : "#1890FF",
              offsetCenter: ["0%", "-30%"],
              formatter: (value) => {
                return `${value}`;
              },
            },
            data: [
              {
                value: nowScore,
              },
            ],
          },
          // 总回款比例
          {
            type: "gauge",
            radius: "100%",
            pointer: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            detail: {
              fontSize: 14,
              color: "#5A5A89",
              offsetCenter: ["0", "70%"],
              formatter: () => {
                return "";
              },
            },
            data: [
              {
                value: 45.5,
              },
            ],
          },
        ],
      };
      this.myChartScore.clear();
      this.myChartScore.setOption(optionScore);
      window.addEventListener("resize", () => {
        this.myChartScore.resize();
      });
      //模拟得分仪表盘
    },
    // 体动详情图表
    getMyChart5(idName, data) {
      if (this.myChart5day !== null) {
        this.myChart5day.dispose();
      }
      console.log(12323322, idName);
      this.myChart5day = this.$echarts.init(document.getElementById(idName));
      var option5 = {
        color: ["#1890FF"],
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(24, 144, 255, 0.8)",
          borderRadius: 5,
          show: true,
          trigger: "axis",
          // trigger: 'item',

          formatter: function (params) {
            console.log(params);
            console.log(data);
            var msg = "";
            msg += params[0].axisValue;
            msg += "～";
            var msg2 = "";
            if (parseInt(params[0].axisValue.slice(3)) < 45) {
              msg2 =
                params[0].axisValue.slice(0, 2) +
                ":" +
                (parseInt(params[0].axisValue.slice(3)) + 15).toString();
            } else {
              if (parseInt(params[0].axisValue.slice(0, 2)) < 9) {
                msg2 +=
                  "0" +
                  (parseInt(params[0].axisValue.slice(0, 2)) + 1).toString() +
                  ":" +
                  "00";
              } else if (parseInt(params[0].axisValue.slice(0, 2)) == 23) {
                msg2 += "00:00";
              } else {
                msg2 +=
                  (parseInt(params[0].axisValue.slice(0, 2)) + 1).toString() +
                  ":" +
                  "00";
              }
            }
            msg += msg2 + "<br>";
            msg += "体动" + params[0].data + "次";
            return msg;
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "8%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            axisLabel: {
              show: false,
              spanStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              interval: 3,
            },
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: false,
            },
            boundaryGap: false,
            data: data.xAxis.data,
          },
        ],
        yAxis: [
          {
            max: data.yAxis.max,
            type: "value",
            splitLine: {
              show: true,
            },
            // z: 10,
            minInterval: 1, //设置最小间隔为1，防止出现小数
            axisLine: {
              lineStyle: {
                color: "rgba(0,0,0,0.15)",
              },
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLabel: {
              spanStyle: {
                color: "rgba(0,0,0,0.35)", //坐标的字体颜色
              },
              margin: 18,
              show: true,
            },
          },
        ],
        series: [
          {
            // name: "1",
            type: "bar",
            barGap: 0,
            barCategoryGap: 1,
            barMinHeight: 1,
            itemStyle: {
              normal: {
                barBorderRadius: [4, 4, 0, 0],
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: "#4D8EF7",
                  },
                  {
                    offset: 1,
                    color: "#C394FE",
                  },
                ]),
              },
            },
            // data: this.detailsData.turnOverData
            //   ? this.detailsData.turnOverData
            //   : [],
            data: data.series.data,
          },
        ],
      };
      this.myChart5day.setOption(option5);
    },
  },
};
</script>

<style lang="scss">
.progress-why {
  width: 16px;
  height: 16px;
  background: #faad14;
  border-radius: 8px;
  display: inline-block;
  font-size: 12px;
  color: white;
  line-height: 16px;
}
.comment {
  width: 100%;
  height: 220px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  .left-comment {
    width: 344px;
    box-sizing: border-box;

    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #fff;
    .left-comment-top {
      width: 100%;
      display: flex;
      padding: 20px 34px 0px;
    }
    .score-ranking-div {
      width: 100px;
      margin-right: 24px;
      position: relative;
    }
    .score-ranking-tips {
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -45%);
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      background: #1890ff;
      padding: 0 4px;
      border-radius: 15px;
    }
    .score-ranking-tips-red {
      background: #ff7186;
    }
    .score-ranking {
      background: #f3f4f7;
      border-radius: 13px;
      position: relative;
      padding: 4px 8px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5e6779;
      white-space: nowrap;
    }
    .score-ranking::after {
      position: absolute;
      content: "";
      display: inline-block;
      border: 8px solid transparent;
      border-bottom-color: #f3f4f7;
      top: -15px;
      left: 50%;
      transform: translateX(-50%);
    }
    .progress-div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .progress-item {
        width: 48px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .progress-pop {
          position: absolute;
          top: 0;
          left: 0;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
          border-radius: 13px;
          background: #fff;
          padding: 2px 5px;
          width: 44px;
          font-size: 12px;
          color: #1890ff;
          font-weight: 900;
        }

        .progress-item-line {
          position: relative;
          height: 50px;
          .progress-item-line-bg {
            width: 10px;
            height: 100%;
            background: #eeeff4;
            border-radius: 5px;
          }
          .progress-item-line-out {
            width: 10px;
            position: absolute;
            bottom: 0;
            left: 0;
            height: 50%;
            border-radius: 5px;
            background: linear-gradient(180deg, #b4a5fb 0%, #508df9 100%);
          }
          .progress-item-line-out-alarm {
            background: linear-gradient(180deg, #ff80ba 0%, #ff7186 100%);
          }
        }

        .progress-decs {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a5a9bc;
          margin: 4px 0;
        }
        .progress-comment {
          text-align: center;
          color: #1890ff;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          background: #1890ff;
          border-radius: 10px;
          padding: 2px 6px;
        }
        .progress-red {
          background: #ff7186;
        }
      }
    }
    .splice-line {
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.06);
      margin-top: 14px;
    }
    .left-comment-bottom {
      width: 100%;
    }
    .left-comment-bottom-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1f2635;
      margin: 10px 32px;
      .color-time {
        color: #1890ff;
      }
      .titlt-conter {
        width: 2px;
        height: 16px;
        margin-right: 15px;
        background: #1f2635;
        opacity: 0.1;
      }
      .index-red-p {
        position: relative;
      }
      .index-red {
        background: rgba(255, 77, 79, 0.1);
        padding: 0 8px;
        color: #ff7186;
        border-radius: 2px 10px 10px 10px;
        position: absolute;
        bottom: -20px;
        white-space: nowrap;
        left: 0;
      }
      .left-comment-bottom-item-image {
        width: 20px;
        height: 20px;
      }
    }

    //background: red;
  }
  .right-comment {
    flex: 1;
    height: auto;
    margin-left: 10px;
    background: #fff;
    padding-left: 32px;
    padding-top: 10px;
    .comment-li-item {
      margin: 10px 0;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #262626;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .comment-li-item-duble {
        display: flex;
        align-items: center;
      }
      .comment-li-item-tips {
        padding: 1px 6px;
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 21px;
        margin-left: 4px;
        background: #1890ff;
        border-radius: 10px 10px 10px 2px;
      }
      .comment-li-item-line {
        width: 2px;
        height: 16px;
        background: #1f2635;
        opacity: 0.1;
        margin: 0 28px;
      }
    }
    .comment-li-item-circle {
      display: inline-block;
      content: "";
      width: 8px;
      height: 8px;
      background: #1890ff;
      border-radius: 50%;
      margin-right: 4px;
    }

    .comment-item {
      width: 100%;

      height: 30px;
      .star-image {
        width: 25px;
        float: left;
      }
      .star-decs {
        margin-left: 5px;
        font-size: 16px;
        color: #262626;
        line-height: 24px;
        float: left;
      }
    }
    .comment-li {
      width: 100%;
      display: flex;
      flex-direction: column;
      .comment-more {
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        margin-left: 10px;
      }
      .first-title {
        width: 15px;
        height: 28px;
        font-size: 24px;
        color: #1890ff;
        line-height: 28px;
        display: inline-block;
        margin-left: 10px;
      }
      .comment-title {
        width: 98px;
        height: 20px;
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        display: inline-block;
        margin-left: 5px;
      }
      .second-title {
        margin-left: 40px;
        width: 15px;
        height: 28px;
        font-size: 24px;
        font-weight: 400;
        color: #ff4d4f;
        line-height: 28px;
        display: inline-block;
      }
      .comment-index {
        display: inline-block;
        margin-top: 10px;
        .index-begin {
          margin-left: 10px;
          width: 8px;
          height: 8px;
          background: #4d8ef7;
          border-radius: 4px;
          display: inline-block;
        }
        .index-title {
          height: 20px;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          display: inline-block;
          margin-left: 5px;
        }
        .index-end {
          height: 20px;
          font-size: 14px;
          color: #1890ff;
          line-height: 20px;
          display: inline-block;
          margin-left: 10px;
        }
        .index-red {
          color: #ff4d4f;
        }
        .index-bak-red {
          background: #ff4d4f;
        }
      }
    }
  }
}
.comment-details-indexs {
  width: 852px;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  .comment-details-item {
    width: 422px;
    box-sizing: border-box;
    break-inside: avoid;
    margin-bottom: 10px;
    .comment-details-item-box {
      width: 100%;
      height: 100%;
      padding: 16px 12px;
      background: #fff;
      .details-title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1f2635;

        .details-title-icon img {
          width: 20px;
          height: 20px;
          margin-right: 4px;
          position: relative;
          top: -2px;
        }
        .details-title-num {
          color: #ff7186;
        }
      }
      .ml24 {
        margin-left: 24px;
      }
      .details-consult {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094a6;
      }
      .tdxq-con {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin: 8px 0;
        .le {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #1f2635;
        }
        .r {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #a5a9bc;
        }
      }
      .detailed-inter {
        background: #f3f4f7;
        border-radius: 2px;
        padding: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094a6;
        margin-top: 4px;
        overflow: hidden;
        .detailstr-circle::before {
          content: "";
          display: inline-block;
          width: 3px;
          height: 3px;
          border-radius: 50%;
          background: #9094a6;
          position: relative;
          top: -4px;
        }
        .advice-item {
          display: flex;
          align-items: center;
          margin: 5px 0;
        }
        .advice-item img {
          width: 34px;
          height: 34px;
          margin-right: 5px;
        }
        .detailed-inter-line {
          width: 100%;
          height: 1px;
          border: 1px solid #e8eaed;
          margin: 12px 0;
        }
        .detailed-inter-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
        }
        .detailed-inter-title img {
          width: 14px;
          height: 14px;
        }
      }
    }
  }
  .is-alarm {
    border: 1px solid rgba(255, 113, 134, 0.5);
  }
}
.tooltip {
  margin-left: 5px;
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted #fff;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 375px;
  background: #ffffff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  color: #ccc;
  border-radius: 6px;
  padding: 20px 20px;

  /* 定位 */
  position: absolute;
  z-index: 1;
  top: -5px;
  left: 105%;
}

.tooltip .tooltiptext {
  top: -150px;
  left: -182px;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 8px;
  border-style: solid;
  border-color: white transparent transparent transparent;
}
.ahi-title {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1f2635;
}
.ahi-title::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 18px;
  background: #4d8ef7;
  border-radius: 2px;
  position: absolute;
  top: 21px;
  left: 0;
}
.ahi-item {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5e6779;
}
.ahi-item::before {
  content: "";
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #4d8ef7;
  border-radius: 50%;
  margin-right: 8px;
}
</style>
